import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { globals } from "../../globals";
import { QueryFilterService } from "../../core/services/query-filter-service";
import { IGridifyQuery } from "gridify-client";
import { TipoSituacaoCadastral } from "../../dominio/enums";
import { PaginatedModel } from "../../dominio/paginated-model";
import { FvFunilModel } from "../../dominio/fv-funil-model";
import { FinanciadoraModel } from "src/app/dominio/financiadora-model";
import { FinanciadoraOctopusModel } from "src/app/dominio/financiadora-octopus-model";
import { ConfigOctopusResponse } from "src/app/services/financiamento.services";

export class FinanciadoraGetManyResponse {
  results?: FinanciadoraModel[];
  pagination?: PaginatedModel;
}

export class HubConfigSchema {
  configSchema?: string;
}

export class FinanciadoraGetSchemaResponse {
  result?: HubConfigSchema;
}

@Injectable({
  providedIn: 'root'
})
export class FinanciadoraService {
  constructor(
    private http: HttpClient,
    private queryFilterService: QueryFilterService
  ) {
  }

  buscarTodos(queryFilter: IGridifyQuery | null = null): Observable<FinanciadoraGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<FinanciadoraGetManyResponse>(`${globals.apiUrl}/api/v2/financiamento/config/financiadoras`, { params });
  }

  buscarTodosV2(queryFilter: IGridifyQuery | null = null): Observable<FinanciadoraGetManyResponse> {
    const params = this.queryFilterService.getQueryParams(queryFilter);

    return this.http.get<FinanciadoraGetManyResponse>(`${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras`, { params });
  }

  buscarSchemaConfig(idFinanciadora: number): Observable<FinanciadoraGetSchemaResponse> {
    return this.http.get<FinanciadoraGetSchemaResponse>(`${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/config/108/schema`);
  }

  buscarConfigOctopus(idFinanciadora: number): Observable<ConfigOctopusResponse> {
    return this.http.get<ConfigOctopusResponse>(`${globals.apiUrl}/api/v2/financiamentos/resources/financiadoras/${idFinanciadora}/config`);
  }

  cadastrar(idTarefa: number, idFinanciadora: number, somentePropostasComSeguro: boolean, octopusConfigModel: string) {
    return this.http.post(`${globals.apiUrl}/api/v2/financiamentos/prisma/celula-credito/${idTarefa}/financiadoras`,
      { idFinanciadora, somentePropostasComSeguro, octopusConfigModel });
  }
}
